<div class="card-body">
    <ul class="list-group list-group-flush">
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ 'tuition-calc.totalTuitionAmountExclVat' | translate
                }}</span>
            <strong>
                @if(isGeneral) {
                {{
                    tuitionFeeSummary.totalTuitionAmountExclVat
                }}
                } @else if(isStudent) {
                    {{ tuitionFeeSummary.totalTuitionAmountExclVatStudent }}
                } @else {
                    {{ tuitionFeeSummary.totalTuitionAmountExclVatCompany }}
                } € </strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ 'tuition-calc.vatAmount' | translate }}</span>
            <strong>
                @if(isGeneral) {
                    {{ tuitionFeeSummary.vatAmount}} 
                } @else if(isStudent) {
                    {{ tuitionFeeSummary.vatAmountStudent }} 
                } @else {
                    {{ tuitionFeeSummary.vatAmountCompany }} 
                } € </strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ 'tuition-calc.totalTuitionAmountInclVat' | translate }}</span>
            <strong>
                @if(isGeneral) {
                    {{ tuitionFeeSummary.totalTuitionAmountInclVat}}
                } @else if(isStudent) {
                    {{ tuitionFeeSummary.totalTuitionAmountInclVatStudent}}
                } @else {
                    {{ tuitionFeeSummary.totalTuitionAmountInclVatCompany}}
                } € </strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ 'tuition-calc.firstInstallmentTuitionAmount' |
                translate }}</span>
            <strong>
                @if(isGeneral) {
                    {{ tuitionFeeSummary.firstInstallmentTuitionAmount}}
                } @else if(isStudent) {
                    {{ tuitionFeeSummary.firstInstallmentTuitionAmountStudent}}
                } @else {
                    {{ tuitionFeeSummary.firstInstallmentTuitionAmountCompany}}
                } € </strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ 'tuition-calc.totalGeneralDiscountAmount' | translate
                }}</span>
            <strong>
                @if(isGeneral) {
                    {{ tuitionFeeSummary.totalGeneralDiscountAmount }}
                } @else if(isStudent) {
                    {{ tuitionFeeSummary.totalStudentDiscountAmount }}
                } @else {
                    {{ tuitionFeeSummary.totalCompanyDiscountAmount }}
                } € </strong>
        </li>
    </ul>
</div>